import type { EditorState } from '@reactvideoeditor/react-video-editor/types';
import type { Creative, CreativeNeoPayload } from '@/types/api';

export const NEO_WRAPPER_VERSION = 2 as const;

export function unwrapNeoEditorState(neo: Creative['neo']): EditorState | undefined {
  if (neo == null || typeof neo !== 'object') return undefined;
  if (neo.version !== NEO_WRAPPER_VERSION) return undefined;
  if (neo.creative == null || typeof neo.creative !== 'object') return undefined;
  return neo.creative as EditorState;
}

export function wrapNeoEditorState(creative: EditorState): CreativeNeoPayload {
  return {
    version: NEO_WRAPPER_VERSION,
    creative,
  };
}
